import {createContext, useState, useContext, ReactNode} from 'react';
import {User} from "@/api/types.ts";

interface AuthUserContext {
  authUser: User | null;
  setAuthUser: (user: User | null) => void;
}

const AuthContext = createContext<AuthUserContext|undefined>(undefined);

export const AuthProvider = ({ children }:{children: ReactNode}) => {
  const [authUser, setAuthUser] = useState<User | null>(null);

  return (
    <AuthContext.Provider value={{ authUser, setAuthUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthUser = (): AuthUserContext => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuthUser must be used within a AuthProvider');
  }

  return context;
};
